<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的发票详情 -->
          <div class="ttshop_coupon min_h">
            <div class="ttshop_couponnav">
              <ul class="clearfloat">
                <li class="active">发票详情</li>
              </ul>
            </div>

            <!-- 发票详情列表 -->
            <div class="ttshop_invoicexq">
              <div class="ttshop_invoicexqlist">
                <h5>订单信息</h5>
                <ul>
                  <li class="clearfloat">
                    <span>订单状态</span>
                    <p v-if="list.order&&list.order.is_pay == 1">已支付</p>
                    <p v-else>未支付</p>
                  </li>
                  <li class="clearfloat">
                    <span>订单编号</span>
                    <p>{{ list.order_no }}</p>
                  </li>
                  <li class="clearfloat">
                    <span>下单时间</span>
                    <p v-if="list.order">{{ list.order.addtime }}</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票类型</span>
                    <p v-if="list.invoice_type == 0">增值税普通发票</p>
                    <p v-else-if="list.invoice_type == 1">增值税普通发票</p>
                    <p v-else-if="list.invoice_type == 2">增值税专用发票</p>
                  </li>
                </ul>
              </div>
              <div class="ttshop_invoicexqlist">
                <h5>发票信息</h5>
                <ul>
                  <li class="clearfloat">
                    <span>发票状态</span>
                    <p v-show="list.status == 2">申请开票</p>
                    <p v-show="list.status == 1">未开票</p>
                    <p v-show="list.status == 3">开票成功</p>
                    <p v-show="list.status == 4">开票失败</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票内容</span>
                    <p>商品明细</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票类型</span>
                    <p v-show="list.bill_type == 0">纸质发票</p>
                    <p v-show="list.bill_type == 1">电子发票</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票抬头</span>
                    <p>{{ list.header }}</p>
                  </li>
                  <li class="clearfloat">
                    <span>税号</span>
                    <p>{{ list.taxpayer }}</p>
                  </li>
                  <template v-if="list.invoice_type == 2">
                    <li class="clearfloat">
                      <span>开户行</span>
                      <p>{{ list.invoice_content.bank_account }}</p>
                    </li>
                    <li class="clearfloat">
                      <span>银行账户</span>
                      <p>{{ list.invoice_content.bank_num }}</p>
                    </li>
                    <li class="clearfloat">
                      <span>注册地址</span>
                      <p>{{ list.invoice_content.register_address }}</p>
                    </li>
                    <li class="clearfloat">
                      <span>注册电话</span>
                      <p>{{ list.invoice_content.register_tel }}</p>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="ttshop_invoicexqlist" v-if="list.status == 3">
                <h5>开票信息</h5>
                <ul>
                  <li class="clearfloat">
                    <span>开票详情</span>
                    <p
                      v-if="list.bill_type == 0"
                      @click.stop="invoice_make"
                      class="make_out_an"
                    >
                      查看开票
                    </p>
                    <p v-if="list.bill_type == 1" class="information">
                      <a
                        v-for="(item, index) in list.invoice_path"
                        :key="index"
                        class="information_title"
                        target="_blank" :href="item" :download="item"
                        >查看发票</a
                      >
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>

    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <div
        v-if="list.invoice_path && list.invoice_path.length"
        class="bill_monad"
      >
        <!-- <img :src="list.invoice_path" alt="" /> -->
        <div class="swiper-container swiper-banner">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in list.invoice_path"
              :key="index"
            >
              <img class="img-default" :src="item" alt />
              <!-- <div class="down_invoice" @click="down_invoice_title(item)">
                <a
                  :href="
                    item + '?response-content-type=application/octet-stream'
                  "
                  target="blank"
                  download
                  >下载发票</a
                >
                下载发票
              </div> -->
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      id: this.$route.query.id,
      list: "",
      dialogVisible: false,
    };
  },
  mounted() {
    this.getinvoiceDetails();
  },
  methods: {
    down_invoice_title(url, name = new Date().valueOf()) {
      this.getUrlBase64(url).then(base64 => {
        let link = document.createElement('a')
        link.href = base64
        link.download = 'qrCode.png'
        link.click()
      })
    },
    getUrlBase64(url) {
      return new Promise(resolve => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url
        img.onload = function() {
          canvas.height = 300
          canvas.width = 300
          ctx.drawImage(img, 0, 0, 300, 300)
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },

    //获取
    getinvoiceDetails() {
      this.$api
        .invoiceDetails({
          order_invoice_id: this.id,
        })
        .then((res) => {
          // console.log(res.data);
          if (res.data.invoice_content &&Object.prototype.toString.call(res.data.invoice_content) === '[object String]'){
            res.data.invoice_content = JSON.parse(res.data.invoice_content);
          }
          if (res.data.invoice_path) {
            res.data.invoice_path = Object.prototype.toString.call(res.data.invoice_path) === '[object String]'?JSON.parse(res.data.invoice_path):res.data.invoice_path;
           res.data.invoice_path= res.data.invoice_path.filter((item, index) => {
              return item != "";
            });
            if (res.data.type == 0) {
              setTimeout(function () {
                var mswiper = new Swiper(".swiper-banner", {
                  autoplay: false,
                  loop: true, // 循环模式选项
                  navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  },
                  effect: "fade",
                  observer: true,
                  observeParents: true,
                  fadeEffect: {
                    crossFade: true,
                  },
                });
              }, 1500);
            }
          }
          this.list = res.data;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    invoice_make() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .ttshop_couponnav {
    width: 100%;
    margin-bottom: 20px;
    ul {
      li {
        float: left;
        cursor: pointer;
        padding-bottom: 10px;
        margin-right: 24px;
        box-sizing: border-box;
        position: relative;
        font-size: 14px;
        line-height: 14px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        &:last-child {
          margin-right: 0;
        }
        &::before {
          content: "";
          width: 00%;
          height: 2px;
          background: #ff0e25;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          -o-transform: translateX(-50%);
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
        }
        &:hover {
          color: #ff0e25;
        }
        &:hover::before {
          width: 100%;
        }
        &.active {
          color: #ff0e25;
        }
        &.active:before {
          width: 100%;
        }
      }
    }
  }
  .ttshop_invoicexq {
    width: 100%;
    .ttshop_invoicexqlist {
      width: 100%;
      margin-bottom: 20px;
      h5 {
        width: 100%;
        height: 38px;
        background: #f5f5f5;
        padding: 0 24px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight:600;
        color: #333;
        font-weight: 500;
        line-height: 38px;
      }
      ul {
        li {
          width: 100%;
          height: 40px;
          border: 1px solid #ebebeb;
          box-sizing: border-box;
          line-height: 40px;
          border-top: 0;
          display: flex;
          align-items: center;
          &:first-child {
            border-top: 1px solid #ebebeb;
          }
          span {
            float: left;
            width: 160px;
            height: 40px;
            border-right: 1px solid #ebebeb;
            font-size: 14px;
            color: #666;
            font-weight: 400;
            padding-left: 24px;
            box-sizing: border-box;
          }
          p {
            float: left;
            width: 788px;
            padding: 0 24px;
            font-size: 14px;
            color: #666;
            font-weight: 400;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}

.bill_monad {
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
}
.make_out_an:hover {
  cursor: pointer;
}
.swiper-banner {
  height: 450px;
}
.swiper-banner img {
  width: 1200px;
  height: 400px;
  object-fit: contain;
}
.down_invoice {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-top: 10px;
}
.down_invoice:hover {
  cursor: pointer;
}
.information {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.information_title {
  margin-left: 15px;
  font-size: 14px;
}
</style>
